





























import { Component, Vue } from 'vue-property-decorator'
import DealGrid from '@/components/deal/DealGrid.vue'
import eventModule from '@/store/event'
import dealModule from '@/store/deal'
import { DealType } from '@/utils/enums'
import { Deal } from '@/types/Deal'

@Component({
  components: {
    DealGrid
  }
})
export default class AllDealsView extends Vue {
  private get isLocal(): boolean {
    return dealModule.type === DealType.LOCAL
  }

  private get showSearchGrid(): boolean {
    return eventModule.searchTerm?.trim().length > 0 || false
  }

  private get searchTitle(): string {
    return this.isLocal
      ? 'UNSERE DEALS IN DEINER NÄHE'
      : 'UNSERE ONLINESHOP GUTSCHEINE'
  }

  private get interestingDeals(): Deal[] {
    return dealModule.interestingDeals
  }

  private get interestingTitle(): string {
    return this.isLocal
      ? 'Empfehlungen in deiner Nähe'
      : 'Empfehlungen für dich'
  }

  private get otherDeals(): Deal[] {
    return dealModule.otherDeals
  }

  private get otherTitle(): string {
    return this.isLocal ? 'Mehr entdecken' : 'Weitere Vorschläge für dich'
  }

  private get nearbyDeals(): Deal[] {
    return dealModule.nearbyDeals
  }

  private get nearbyTitle(): string {
    return 'Weitere Vorschläge in deiner Nähe'
  }
}
